export default {
  title: "Поиск по каталогу",
  placeholder: "Автор, заглавие, ISBN, премия…",
  submit: "Найти",
  results: "Результаты",
  noQueryHint: "Введите запрос или выберите фасет.",
  empty: "По вашему запросу ничего не найдено. Измените формулировку или снимите фильтры.",
  sort: "Сортировка",
  sortRelevance: "По релевантности",
  sortTitle: "По заглавию",
  sortYearDesc: "Сначала новые",
  sortYearAsc: "Сначала старые",
  facets: "Фильтры",
  facetType: "Тип",
  facetYear: "Год",
  facetLanguage: "Язык",
  facetRole: "Роль",
  facetSubject: "Тема",
  facetPrize: "Премия",
  facetPublisher: "Издательство",
  facetSeries: "Серия",
  yearFrom: "Год с",
  yearTo: "Год по",
  clearFacets: "Сбросить фильтры",
  saveQuery: "Сохранить запрос",
  saveQueryTitle: "Название сохранённого запроса",
  saved: "Запрос сохранён в кабинете",
  took: "за {{ms}} мс",
  relatedPeople: "Люди",
  relatedPrizes: "Премии",
  relatedConcepts: "Темы",
  relatedAgents: "Организации",
  clusterEditions: "Издания",
  clusterOrphan: "Произведение не связано",
  moreEditions: "ещё {{count}}",
}
